<template>
	<div>
		<layout-1
			:table_name="'PO Numbers'"
			:id=pageid
			:searchbar=true
			:navbar=true
			:nav_items="['Add PO Number']"
			:nav_item_perms="['72']"
			:button_perm="'71'"
			:button_name="'Select'"
			:term=term
			:reroute="'/0315'"
			:select_reroute=true
			style="width:100%; height:calc(100vh - 50px);"
		></layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.PO_NUMBERS_PAGE,
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/PO_Numbers.vue